/** ERROR TAGS to send to Sentry.io */
/** Tags for Errors to send to sentry.io */
class ErrorTagUtil {
}
// Bundle Errors
ErrorTagUtil.commonMutationObserver = 'CommonMutationObserver';
ErrorTagUtil.eventBus = 'HekateEventBus';
ErrorTagUtil.heartbeat = 'HeartbeatError';
ErrorTagUtil.utmDupe = 'DuplicateUtmParameter';
ErrorTagUtil.personalizationError = 'PersonalizationError';
ErrorTagUtil.searchError = 'FreeTextSearchError';
ErrorTagUtil.ptcDebugClientError = 'PtcDebugClientError';
ErrorTagUtil.hekateInternalError = 'HekateInternalError';
ErrorTagUtil.hekate = 'HekateError';
ErrorTagUtil.hekateLoad = 'HekateLoadError';
ErrorTagUtil.hekateWarning = 'HekateWarning';
ErrorTagUtil.hekateForm = 'HekateFormError';
ErrorTagUtil.hekateSubmit = 'HekateSubmitError';
ErrorTagUtil.hekateSubmitFail = 'HekateSubmitFail';
ErrorTagUtil.hekateRecaptcha = 'HekateRecaptchaError';
ErrorTagUtil.hekateUnifiedSignup = 'HekateUnifiedSignup';
ErrorTagUtil.hekateCsrfToken = 'HekateCsrfToken';
ErrorTagUtil.eloquaDown = 'EloquaDown';
ErrorTagUtil.hekateFailEmailSupport = 'HekateFailEmailSupport';
ErrorTagUtil.aiSearch = 'AiSearchError';
ErrorTagUtil.aiSearchPrefetch = 'AiSearchPrefetchError';
ErrorTagUtil.aiSearchRequest = 'AiSearchRequestError';
ErrorTagUtil.aiSearchShowMoreResults = 'AiSearchShowMoreResultsError';
ErrorTagUtil.aiSearchRetry = 'AiSearchRetryError';
export default ErrorTagUtil;
